import Navbar1 from "../components/Navbar.jsx";
import HeroSection from "../components/HeroSection";
import TrustedBySection from "../components/TrustedBySection";
import PropertyCategoriesSection from "../components/PropertyCategoriesSection";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import HowItWorksSection from "../components/HowItWorksSection";
import FeaturesSection from "../components/FeaturesSection";
import EcosystemAndCommissionSection from "../components/EcosystemAndCommissionSection";
import ProductivitySection from "../components/ProductivitySection";
import OwnerListingSection from "../components/OwnerListingSection";
import VideoTestimonialsSection from "../components/VideoTestimonialsSection";
import FeaturedInSection from "../components/FeaturedInSection";
import TestimonialsSection from "../components/TestimonialsSection";
import FAQSection from "../components/FAQSection";
import DemoSection from "../components/DemoSection";
import ProBrokerFooter from "../components/ProBrokerFooter";

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userId = Cookies.get("userId");
    const token = Cookies.get("token");
    if (userId && token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background overflow-hidden">
      <div className="relative">
        <Navbar1 />
        <HeroSection />
      </div>
      <TrustedBySection />
      <PropertyCategoriesSection />

      <HowItWorksSection />
      <FeaturesSection />
      <EcosystemAndCommissionSection />
      <ProductivitySection />
      <OwnerListingSection />
      {/* <VideoTestimonialsSection /> */}
      <FeaturedInSection />
      <TestimonialsSection />
      <FAQSection />
      <DemoSection />
      <ProBrokerFooter />
    </div>
  );
};

export default Index;
